/**
 * Best-effort extraction of a numeric value from CC's pricingLabel strings
 * like "$250", "$1,300", "Starting at $450". Falls back to 0 if no number
 * is found. Used for the GA4 `value` field on conversion events and for
 * the cart subtotal on promo validation.
 */
export function parsePrice(label: string): number {
  if (!label) return 0;
  const m = label.replace(/,/g, '').match(/\$\s*(\d+(?:\.\d+)?)/);
  return m && m[1] ? Number(m[1]) : 0;
}
